export default {"src":"/_next/static/media/1.e5ab4fa6.svg","height":38,"width":38,"blurWidth":0,"blurHeight":0};